module.exports = {"id":"226377","name":"Gonzalo Martínez","rating":"77","photo":"./data/images/photos/1/226377.png","club":{"name":"River Plate","logo":"./data/images/clubs/RiverPlate.png"},"positions":["MOC","MG","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GonzaloMartinez0.json
// module id = 1626
// module chunks = 0